import { createReducer } from "typesafe-actions";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import RecordsCadenceEffectivenessBand from "@app/types/dashboard/cards/recordsCadenceEffectiveness/RecordsCadenceEffectivenessBand";
import RecordsCadenceEffectivenessCardConfiguration from "@app/types/dashboard/cards/recordsCadenceEffectiveness/RecordsCadenceEffectivenessCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyRecordsCadenceEffectivenessDrillDownListViewSettings,
  fetchRecordsCadenceEffectivenessCardDrillDownData,
  hideRecordsCadenceEffectivenessDrillDown,
  RecordsCadenceEffectivenessCardActions,
  setRecordsCadenceEffectivenessDrillDownBand,
  showRecordsCadenceEffectivenessDrillDown,
} from "./actions";

export interface RecordsCadenceEffectivenessCardState {
  /** The overdue band currently drilled into (drives the grid's `cadenceDaysOut` range). */
  band?: RecordsCadenceEffectivenessBand;
  /** Set while the drilldown is open; also the per-card "visible" trigger (visible if set). */
  configuration?: RecordsCadenceEffectivenessCardConfiguration;
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const recordsCadenceEffectivenessInitialState: RecordsCadenceEffectivenessCardState = {
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const recordsCadenceEffectivenessState = createReducer<
  RecordsCadenceEffectivenessCardState,
  RecordsCadenceEffectivenessCardActions
>(recordsCadenceEffectivenessInitialState)
  .handleAction(showRecordsCadenceEffectivenessDrillDown.request, (state, { payload }) => ({
    ...state,
    band: payload.band,
    configuration: payload.configuration,
  }))
  .handleAction(showRecordsCadenceEffectivenessDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(setRecordsCadenceEffectivenessDrillDownBand, (state, { payload }) => ({
    ...state,
    band: payload,
  }))
  .handleAction(hideRecordsCadenceEffectivenessDrillDown, (state) => ({
    ...state,
    configuration: undefined,
  }))
  .handleAction(fetchRecordsCadenceEffectivenessCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(
    fetchRecordsCadenceEffectivenessCardDrillDownData.success,
    (state, { payload }) => ({
      ...state,
      loading: false,
      totalFilteredRecords: payload.totalFilteredRecords,
      totalRecords: payload.totalRecords,
    })
  )
  .handleAction(fetchRecordsCadenceEffectivenessCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(
    applyRecordsCadenceEffectivenessDrillDownListViewSettings,
    (state, { payload }) => ({
      ...state,
      viewState: {
        ...state.viewState,
        columns: payload.columns ?? state.viewState.columns,
        filter: payload.filter ?? state.viewState.filter,
        range: payload.range ?? state.viewState.range,
        sort: payload.sort ?? state.viewState.sort,
      },
    })
  );

export default recordsCadenceEffectivenessState;
